import { mapState } from 'vuex';
import { mapActions } from 'vuex';

import { TIPO_GRUPO } from '../../util/constantes';

export default {
  data() {
    return {
      infiniteLoadingId: 0,

      idTipoConta: undefined,
      loadingTipoDespesas: false,
      loadingGrupoConta: false,

      tipoDespesasPesquisa: [],

      filtroTipoConta: 'TODOS',

      isGrupoOuSubgrupo: 'GRUPO',

      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    }
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "GRUPOS_CONTA"
          })[0];
      },
      isTipoContaHabilitado(state) { return state.usuarioLogado.imobiliaria.parametros.tipoESubgrupoConta }
    }),
    ...mapState('gruposContaStore', {
      gruposConta(state) { return state.listaGruposConta },
      grupoContaPesquisa(state) { return state.grupoContaPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      grupoConta(state) { return state.grupoContaSelecionado },
      listaTipoDespesa(state) { return state.listaTipoDespesa },
      gruposDisponiveis(state) { return state.gruposDisponiveis }
    }),
    tiposGrupo() {
      return TIPO_GRUPO;
    },
    exibirBotaoNovoGrupoConta() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarGrupoConta() {
      return(
        (this.grupoConta.id === 0 && this.permissoes.cadastro)
        || (this.grupoConta.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverGrupoConta() {
      return this.grupoConta.id != 0 && this.permissoes.remocao;
    },

    tipoContaIsVisible() {
      return this.isTipoContaHabilitado == true
    },

    validacao() {
      return {
        nome: [
          { required: true, message: "Nome é obrigatório." }
        ],
        grupoPai: [
          { required: true, message: "Tipo de conta é obrigatório." }
        ]
      }
    },

    addSubGrupo() {
      return this.isGrupoOuSubgrupo == 'SUBGRUPO'
    },

    labelNome() {
      return this.isGrupoOuSubgrupo == 'GRUPO' ? 'Nome do Grupo' : 'Nome do Subgrupo'
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('gruposContaStore', [
      'listarGruposConta',
      'limparGruposContaListadas',
      'limparGrupoContaPesquisa',
      'recuperarGrupoConta',
      'novoGrupoConta',
      'gravarGrupoConta',
      'removerGrupoConta',
      'listarTipoDespesa',
      'listarGruposContaSelect'
    ]),

    labelFiltroTipo() {
      return this.isTipoContaHabilitado ? 'Tipo' : 'Finalidade'
    },

    novo() {
      this.novoGrupoConta();
      this.idTipoDespesa = undefined;
      this.tabSelecionada = 'detalhes';
    },

    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },

    pesquisarHandler() {
      this.grupoContaPesquisa.pagina = 0;
      this.limparGruposContaListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      const payload = {
        ...this.grupoContaPesquisa,
      }


      if(this.grupoContaPesquisa.pagina === 0) { this.showLoading(); }

      this.listarGruposConta(payload).then((resultado) => {
        if(this.grupoContaPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.grupoContaPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.grupoContaPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.grupoContaPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    limparPesquisa() {
      this.limparGrupoContaPesquisa();
    },
    recuperarHandler(grupoConta) {
      this.recuperar(grupoConta);
    },
    recuperar(grupoConta) {
      const payload = {
        ...grupoConta,
      }


      this.showLoading();
      this.recuperarGrupoConta(payload).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    gravar() {
      const payload = {
        ...this.grupoConta,
        grupoPai  : this.grupoConta.grupoPai
      }
      if(this.grupoConta.grupoPai) {
        delete this.grupoConta.grupoPai.tipoConta
        delete this.grupoConta.grupoPai.pesquisaTipoConta
        delete this.grupoConta.grupoPai.grupoPai
      }

      this.showLoading();
      this.gravarGrupoConta(payload).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.filtroTipoConta = 'TODOS'
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerHandler() {
      this.$confirm('Deseja realmente remover este Grupo de Contas?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerGrupoConta(this.grupoConta).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    filtrarTiposContaSelect(queryString) {
      let tipoSelecionado = undefined
      if(this.filtroTipoConta !== 'TODOS') {
        tipoSelecionado = this.filtroTipoConta;
      }

      let payload = { nome: queryString, tipo: tipoSelecionado }
      this.loadingTipoDespesas = true;
      this.listarTipoDespesa(payload)
      .then(() => {
      this.loadingTipoDespesas = false;  
      })
    },

    filtrarTiposContaPesquisa(queryString) {
      let payload = { nome: queryString }
      this.loadingTipoDespesas = true;
      this.listarTipoDespesa(payload)
      .then((resultado) => {
        this.tipoDespesasPesquisa = resultado.lista;
        this.loadingTipoDespesas = false;
      })
    },

    filtrarGruposConta(queryString) {
      let payload = { nome: queryString }
      this.loadingGrupoConta = true;
      this.listarGruposContaSelect(payload)
      .then(() => {
        this.loadingGrupoConta = false;
      })
    }
  }
}